import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll øjeblikkeligt til toppen uden animation
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Dette sikrer øjeblikkelig scroll uden animation
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop; 